import api from 'api';

export const createPromoCode = api('POST /api/promocodes/promocode');
export const createPromoCodeSet = api('POST /api/promocodes/promocode/set');
export const loadPromoCode = api('GET /api/promocodes/promocode/:id');
export const loadPromoCodeDetails = api(
  'GET /api/promocodes/promocode/:id/details'
);

export const editPromoCode = api('PUT /api/promocodes/promocode/:id');
export const editPromoCodeSet = api('PUT /api/promocodes/promocode/set/:id');

export const deactivatePromoCode = api(
  'GET /api/promocodes/promocode/:id/deactivate'
);

export const validatePromoCode = api('POST /api/promocodes/promocode/validate');

export const exportSet = api('GET /api/promocodes/promocode/:id/export', {
  responseType: 'blob',
});

export const getRedemptionReport = api(
  'GET /api/promocodes/promocode/:id/redemptionreport',
  {
    responseType: 'blob',
  }
);

export const setReceiveNotifications = api(
  'PUT /api/promocodes/promocode/:id/set-receive-notifications'
);
